module.exports = __webpack_public_path__ + "static/media/rmICon1.c3af4295.png";